import ParticipantIndicator from './components/ParticipantIndicator';

export { ParticipantIndicator };
export default ParticipantIndicator;
